import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { RouterModule } from '@angular/router';

@Component({
    selector: 'app-part-header',
    imports: [
        RouterModule,
        MatButtonModule,
        MatIconModule
    ],
    templateUrl: './part-header.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './part-header.component.scss'
})
export class PartHeaderComponent {

}
